// @flow

import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Carousel from 'react-elastic-carousel'
import { cartActions } from '../../../store/actions'
import { HELPER, APP_HELPER } from '../../../utils'

function ElasticCarousel() {
	let dispatch = useDispatch()
	const { categories, selected_category, productsPerPage, productsCurrentPage } = useSelector(
		(state) => state.inventory
	)
	
	const {config} = useSelector((state) => state)

	const [activeIndex, setActiveIndex] = useState(0)

	const onCategorySelection = (category, params) => {
		dispatch(cartActions.UPDATE_CATEGORY_SELECTION(category, params))
	}
	return (
		<ul>
			{!HELPER.isEmpty(categories) ? (
				<Carousel
					itemsToShow={5}
					showArrows={categories.length === 1 ? false : true}
					isRTL={!APP_HELPER.CHECK_LTR_LANG()}
					disableArrowsOnEnd={true}
					focusOnSelect={false}
					enableSwipe={false}
					enableMouseSwipe={false}
					outerSpacing={0}
					// enableAutoPlay={true}
					enableTilt={true}
					tiltEasing={'ease'}
					breakPoints={[
						{ width: 1, itemsToShow: 2, itemsToScroll: 1 },
						{ width: 550, itemsToShow: 3, itemsToScroll: 1 },
						{ width: 850, itemsToShow: 4, itemsToScroll: 1 },
						{ width: 1150, itemsToShow: 4, itemsToScroll: 1 },
						{ width: 1450, itemsToShow: 5, itemsToScroll: 1 },
						{ width: 1750, itemsToShow: 5, itemsToScroll: 1 },
					]}
					initialActiveIndex={activeIndex}
				>
					
					{categories.filter((item) => {
						const currentCat = item.category;
						if (config.merchant.is_all_product_enable === 0 && currentCat.name !== "All Products") {
							return true;
						}
						if (config.merchant.is_all_product_enable !== 0) {
							return true;
						}
						return false;
					}).map((category, i) => {
						let selectedCat = selected_category?.id === category?.category?.id
						if (activeIndex !== i && selectedCat) {
							setActiveIndex(i)
						}
						return (
							<li
								className={selectedCat ? 'selectedCat insideListedItem' : 'insideListedItem'}
								key={category?.category?.id}
								onClick={() => {
									onCategorySelection(category, { productsPerPage, productsCurrentPage })
								}}
							>
								<div className="listedItemBox">
									<span className="">{HELPER.titleCase(category?.category.name)}</span>
								</div>
							</li>
						)
					})}
				</Carousel>
			) : (
				''
			)}
		</ul>
	)
}

function Categories() {
	let dispatch = useDispatch()
	const { visibleProducts } = useSelector((state) => state.inventory)
	const { catalog_info_loading, catalogue_key } = useSelector((state) => state.config)
	const { categories, selected_category, productsPerPage, productsCurrentPage } = useSelector(
		(state) => state.inventory
	)

	useEffect(() => {
		if (!HELPER.isEmpty(selected_category?.id) && !catalog_info_loading) {
			let selectedCategory = categories.find((category) => {
				return selected_category?.id === category?.category?.id
			})
			if (
				catalogue_key !== window.location.pathname.split('/')[1] ||
				visibleProducts.length === 0
			) {
				dispatch(
					cartActions.UPDATE_CATEGORY_SELECTION(selectedCategory, {
						productsPerPage,
						productsCurrentPage,
					})
				)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selected_category, catalog_info_loading])
	return (
		<div className="catListingWrap">{HELPER.isEmpty(categories) ? '' : <ElasticCarousel />}</div>
	)
}

export default Categories
